<template>
  <svg
    width="72"
    height="72"
    viewBox="0 0 72 72"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="36"
      cy="36"
      r="36"
      transform="rotate(-180 36 36)"
      fill="#5061FA"
    />
    <circle
      cx="36"
      cy="36"
      r="27.5"
      fill="#5061FA"
      stroke="white"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M31.4571 24C30.5735 24 29.8571 24.7163 29.8571 25.6V27.1426H25C23.3431 27.1426 22 28.4858 22 30.1426V42.9999C22 44.6568 23.3431 45.9999 25 45.9999H47.2859C48.9427 45.9999 50.2859 44.6567 50.2859 42.9999V30.1426C50.2859 28.4858 48.9427 27.1426 47.2859 27.1426H42.4286V25.6C42.4286 24.7163 41.7123 24 40.8286 24H31.4571Z"
      fill="white"
    />
    <circle
      cx="36.1429"
      cy="36.5714"
      r="6.28575"
      fill="#5061FA"
    />
  </svg>
</template>
